import React, { FunctionComponent } from 'react';
import { CompaniesSearchForm } from '../../molecules/companiesSearchForm';
import { CompaniesList } from '../../organisms/companiesList';
import type { Props as ComponentProps, SortBy } from './types';


type Props = ComponentProps & {
  loading: boolean;
  totalCount: number;
  filteredCompaniesCount: number;
  dataCategory: any;
  dataValue: any;
  q: string;
  industryId: string;
  industryIds: string[];
  selectedIndustry: number | null;
  displayedCompanyIds: number[];
  initialCompanyIds: number[];
  page: number;
  totalPages: number;
  itemsPerPage: number;
  sortBy: string;
  handleSearch: (companyName: string, selectedIndustries: number[], shouldUpdateList: boolean) => void;
  fetchFilteredCompanies: (override?: {
    q?: string;
    industryIds?: string[];
    page?: number;
    sortBy?: SortBy;
    selectedIndustry?: number | null;
  }) => Promise<void>;
  handleIndustryChange: (industryIdParam: number) => void;
  updateFilteredCount: (companyName: string, selectedIndustries: number[]) => void;
  handlePageChange: (newPage: number) => void;
  handleSortChange: (sortOption: any, sortedIds: number[]) => void;
  handleModalOn: () => void;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  return (
    <div className="l-articles js-background-fixed">
      <div className="l-articles-inner u-clear">
        <h1 className="articles-title">
          {props.industryName
            ? `ファッション・アパレル業界 ${props.industryName}の会社一覧`
            : 'ファッション・アパレル業界の会社一覧'}
        </h1>
        <CompaniesSearchForm
          onSearch={props.handleSearch}
          totalCount={props.totalCount}
          filteredCompaniesCount={props.filteredCompaniesCount}
          fetchFilteredCompanies={props.fetchFilteredCompanies}
          updateFilteredCount={props.updateFilteredCount}
          q={props.q}
          industryId={props.industryId}
          industryIds={props.industryIds}
          industries={props.industries}
          loading={props.loading}
          showIndustryFilter={props.showIndustryFilter}
          onIndustryChange={props.handleIndustryChange}
          selectedIndustry={props.selectedIndustry}
        />
        <CompaniesList
          companyIds={props.displayedCompanyIds}
          initialCompanyIds={props.initialCompanyIds}
          currentPage={props.page}
          totalPages={props.totalPages}
          onPageChange={props.handlePageChange}
          totalCount={props.totalCount}
          itemsPerPage={props.itemsPerPage}
          loading={props.loading}
          sortBy={props.sortBy}
          user={props.user}
          onSortChange={props.handleSortChange}
          handleModalOn={props.handleModalOn}
          noCompanyIcon={props.noCompanyIcon}
          dataCategory={props.dataCategory}
          dataValue={props.dataValue}
          lineIcon={props.lineIcon}
        />
      </div>
    </div>
  );
};
